import React, { useState } from "react";
import { motion } from "framer-motion";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../Firebase";
import { useNavigate, Link } from "react-router-dom";
import { FaLock, FaArrowLeft } from "react-icons/fa6";
import { BRAND_NAME } from "../services/seedData";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/admin");
    } catch (err) {
      setError("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <motion.div
        className="glass-card login-card"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ position: "relative", zIndex: 1 }}
      >
        {/* Brand */}
        <div className="login-brand">{BRAND_NAME}</div>

        {/* Lock icon */}
        <div className="login-icon-wrap">
          <FaLock />
        </div>

        <h2 className="login-title">Admin Access</h2>
        <p
          style={{
            textAlign: "center",
            color: "var(--text-muted)",
            fontSize: 14,
            marginBottom: 32,
          }}
        >
          Sign in to manage your portfolio data
        </p>

        {error && (
          <div className="status-badge status-error" style={{ marginBottom: 12, width: "100%", justifyContent: "center" }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              className="form-input"
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <input
              className="form-input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            className="btn-glow"
            style={{ width: "100%", justifyContent: "center" }}
            disabled={loading}
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: 28 }}>
          <Link
            to="/"
            className="login-back-link"
          >
            <FaArrowLeft size={11} /> Back to Portfolio
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default Login;
